module.exports = __webpack_public_path__ + "img/salary-company.9608c78d.svg";